/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Container,
} from "@material-ui/core";
import ModalImage from "react-modal-image";
import CircularProgress from "@mui/material/CircularProgress";

import Resizer from "react-image-file-resizer";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import PageTitle from "../../components/pageTitle/PageTitle";
import {
  getChannelList,
  sendMessageToChannel,
  updateChannel,
  getMessages,
} from "../../services/apiservices/messages";

import AuthContext from "../../hooks/authContext";
import moment from "moment";
import { useMediaQuery } from "@mui/material";
import { getAllEmployee } from "../../services/apiservices/employee";
import { packageAccess } from "../../services/helpers";
import { CommonSuccessDialog, StorageLimitAccess } from "../../components/DialogComponent/SupplyDataDialog";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/Tabs/Tabs";
import { ArrowLeft, ArrowUp, Eye, Flag, Paperclip, X } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import EmptyStateMessage from "./EmptyStage";
import clsx from "clsx";
import ChatHeader from "./ChatHeader";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textArea";
import { ScrollArea } from "../../components/ui/scrollArea";
import { Avatar, AvatarFallback } from "../../components/ui/avtar";
import { Badge } from "../../components/ui/badge";
import { useNavigate } from "react-router";

const ChatLeftPannel = ({ activeTab, isMobile, isLandscape, setActiveTab }) => {
  const auth = useContext(AuthContext);
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;
  const [pvtChannels, setPVTChannels] = React.useState([]);
  const [pubChannels, setPUBChannels] = React.useState([]);

  useEffect(() => {
    if (!auth?.userProfile?.id) return; 
    getChannelList(companyId,
      (res) => {
        if (res) {
          const response = res?.filter((item)=> item.status !== false);
          const user = auth?.userProfile;
          const isEmployee = Array.isArray(user?.role) ? user.role.includes("Employee") : user?.role === "Employee";
          const isClient = user?.role === "Client";
          const isAdminOrCompanyUser = user?.role === "companyUser";
          const isEmployeeAdmin = isEmployee && user?.employeerole === "Admin";

          const publicChannels = response?.filter((item) => item?.type === "Public");
          const privateChannels = response?.filter((item) => {
              if (item?.type !== "Private") return false;

              if (isAdminOrCompanyUser) {
                return true;
              }

              if (isEmployeeAdmin) {
                return true;
              }

              if (isEmployee && user?.employeerole !== "Admin") {
                return (
                  Array.isArray(item?.employee) &&
                  item?.employee?.some((emp) => emp?.id === user?.id)
                );
              }

              if (isClient) {
                return (
                  item?.clientChannel === true &&
                  item?.client === user?.id
                );
              }

              return false;
            });

          const data = [...publicChannels, ...privateChannels];
          // const data = data?.filter(
          //   (item) =>
          //     (auth?.userProfile?.role !== "Client" ||
          //       auth?.userProfile?.client === item?.client)
          // );
          const pvtChn = [];
          const pubChn = [];
          let isReadPriv = true;
          let isReadPubl = true;
          data?.forEach((element) => {
            if (element.type === "Private") {
              if (isReadPriv) {
                isReadPriv =
                  element?.readMsgUsers?.includes(auth.userProfile.id) ||
                  element?.id === auth.currentChannel?.id
                    ? true
                    : false;
              }
              pvtChn.push(element);
            } else {
              pubChn.push(element);
              if (isReadPubl) {
                isReadPubl =
                  element?.readMsgUsers?.includes(auth.userProfile.id) ||
                  element?.id === auth.currentChannel?.id
                    ? true
                    : false;
              }
            }
          });

          auth.setIsReadPublic(isReadPubl);
          auth.setIsReadPrivate(isReadPriv);
          setPUBChannels(pubChn);
          setPVTChannels(pvtChn);
        }
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
    // return unsubscribe;
    // fetchChannelList();
  }, [auth, activeTab]);
  const onChannelClickHandler = (channel) => {
    auth.setCurrentChannel(channel);
  };

  const onChangeTab = (value) => {
    if(value !== activeTab){
      auth.setCurrentChannel(null);
    }
    setActiveTab(value);
  }


  const hasUnreadPrivate = pvtChannels?.some(
    (channel) =>
      !channel?.readMsgUsers?.includes(auth?.userProfile?.id) &&
      channel?.id !== auth?.currentChannel?.id
  );

  const hasUnreadPublic = pubChannels?.some(
    (channel) =>
      !channel?.readMsgUsers?.includes(auth?.userProfile?.id) &&
      channel?.id !== auth?.currentChannel?.id
  );

  return (
    <Tabs defaultValue={activeTab} onValueChange={onChangeTab} className="w-full">
      <TabsList className="grid w-full grid-cols-2 p-4">
        <TabsTrigger
          value="Private"
          className={clsx(
            "relative py-2 px-4 text-center text-sm font-medium border rounded-sm",
            activeTab === "Private"
              ? "bg-green-600 text-white"
              : "bg-gray-100 text-gray-800 hover:bg-gray-200"
          )}
        >
          Private
          {hasUnreadPrivate && (
            <span  style={{ top: "14px" }} className="absolute right-6 h-2 w-2 rounded-full bg-orange-500"></span>
          )}
        </TabsTrigger>
        <TabsTrigger
          value="Public"
          className={clsx(
            "relative py-2 px-4 text-center text-sm font-medium border rounded-sm",
            activeTab === "Public"
              ? "bg-green-600 text-white"
              : "bg-gray-100 text-gray-800 hover:bg-gray-200"
          )}
        >
          Public
          {hasUnreadPublic && (
            <span className="absolute top-3 right-6 h-2 w-2 rounded-full bg-orange-500"></span>
          )}
        </TabsTrigger>
      </TabsList>

      <TabsContent value="Private" className="mt-12">
        <div className="space-y-3 px-1 py-2">
          {pvtChannels?.length > 0 ? (
            pvtChannels?.map((channel) => (
            <button
              key={channel.id}
              className={clsx(
                "w-full flex items-center justify-between rounded-lg p-12 text-left transition",
                auth?.currentChannel?.id === channel.id
                  ? "bg-[#157f3c33]  border"
                  : "hover:bg-gray-100 hover:dark:text-gray-500"
              )}
              onClick={() => onChannelClickHandler(channel)}
            >
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium">{channel?.groupName}</span>
                  {!channel?.readMsgUsers?.includes(auth.userProfile.id) &&
                    channel?.id !== auth.currentChannel?.id && (
                      <Flag className="h-4 w-4 text-orange-600" />
                    )}
                </div>
                <p className="text-xs text-muted-foreground mt-2">{channel?.description}</p>
              </div>
            </button>
          )) 
           ) : (
            <div className="text-center mt-24 px-4">
              <p className="text-base font-semibold text-gray-800 dark:text-white">
                Please create a Private Channel
              </p>
              <p className="text-sm text-muted-foreground mt-8">
                Private channels are only viewable to members you have added to the channel.
              </p>
            </div>
        )}
        </div>
      </TabsContent>

      <TabsContent value="Public" className="mt-12">
        <div className="space-y-3 px-1 py-2">
          {pubChannels?.length > 0 ? (
            pubChannels?.map((channel) => (
            <button
              key={channel.id}
              className={clsx(
                "w-full flex items-center justify-between rounded-lg p-12 text-left transition",
                auth?.currentChannel?.id === channel.id
                  ? "bg-[#157f3c33]  border"
                  : "hover:bg-gray-100 hover:dark:text-gray-500"
              )}
              onClick={() => onChannelClickHandler(channel)}
            >
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium">{channel?.groupName}</span>
                  {!channel?.readMsgUsers?.includes(auth.userProfile.id) &&
                    channel?.id !== auth.currentChannel?.id && (
                      <Flag className="h-4 w-4 text-orange-600 mt-2" />
                    )}
                </div>
                <p className="text-xs text-muted-foreground">{channel?.description}</p>
              </div>
            </button>
          ))
          ) : (
          <div className="text-center mt-24 px-4">
            <p className="text-base font-semibold text-gray-800 dark:text-white">
              Please create a Public Channel
            </p>
            <p className="text-sm text-muted-foreground mt-8">
              Public channels are viewable to any one in your organization
            </p>
          </div>
        )}
        </div>
      </TabsContent>
    </Tabs>
  );
};

const SendTextMessageBox = ({
  currChannel,
  employee,
  companyId,
  setDialogOpen,
}) => {
  const imgRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(null);
  const auth = useContext(AuthContext);
  const [msgText, setMsgText] = useState("");
  const [currentImage, setCurrentImage] = useState();
  const [displayImage, setDisplayImage] = useState([]);
  // const [compressImage, setCompressImage] = useState([]);
  const [imageLink, setImageLink] = useState([]);
  const [alertDialog, setAlertDialog] = useState(false);
  const userPackageId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(userPackageId);
  const hasMediaAccess = allowedPermissions?.routes?.includes("CHAT_MEDIA");
  const onChangeTextHandler = (eve) => {
    setMsgText(eve.target.value);
  };

  const sendMessage = () => {
    const message = {
      channelId: currChannel.id,
      sender: {
        userId: auth.userProfile.id,
        firstName: auth.userProfile.firstName,
        lastName: auth.userProfile.lastName,
      },
      type: currentImage && currentImage !== "" ? "image" : "text",
      readBy: [],
      message: msgText,
      image: imageLink ? imageLink : "",
      cimage: displayImage ? displayImage : "",
    };

    let empFound = currChannel.employee.find(
      (emp) => emp.id === auth.userProfile.id
    );

    if (!empFound) {
      const emp = {
        id: auth.userProfile.id,
        firstName: auth.userProfile.firstName,
        lastName: auth.userProfile.lastName,
        email: auth.userProfile.email,
        phone: auth.userProfile.phoneNumber,
      };
      if (currChannel.employee) {
        currChannel.employee.push(emp);
      } else {
        currChannel.employee = [emp];
      }
    }
    setMsgText("");
    currChannel.last_message = msgText;
    currChannel.readMsgUsers = [auth.userProfile.id];
    const channelUpdates = Object.assign({}, currChannel);
    updateChannel(currChannel.id, channelUpdates);
    sendMessageToChannel(
      message,
      (res) => {
        removeSelectedImage(0, false);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const uploadPhoto = (currentFile, files, index, imgLink = []) => {
    const timestamp = moment().valueOf().toString();
    const storage = getStorage();
    const filePath = `${companyId}/chat/${timestamp}_${currentFile.name}`;
    const fileRef = ref(storage, filePath);

    uploadBytes(fileRef, currentFile)
      .then(() => {
        return getDownloadURL(fileRef);
      })
      .then((downloadURL) => {
        imgLink.push(downloadURL);
        setImageLink(imgLink);

        if (files.length > index + 1) {
          uploadPhoto(files[index + 1], files, index + 1, imgLink);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const resizeImage = (files, index, callbackAfterFinish, disImages = []) => {
    const prefixFiletype = files[index].type.toString();
    if (prefixFiletype.indexOf("image/") === 0) {
      try {
        Resizer.imageFileResizer(
          files[index],
          200,
          200,
          "JPEG",
          50,
          0,
          (uri) => {
            disImages.push(uri);

            if (files.length > index + 1) {
              setDisplayImage(disImages);
              resizeImage(files, index + 1, callbackAfterFinish, disImages);
            } else {
              callbackAfterFinish(disImages, 1);
            }
          },
          "base64",
          100,
          100
        );
      } catch (err) {
        callbackAfterFinish(err, 0);
        console.log(err);
      }
    } else {
      if (files.length > index + 1) {
        resizeImage(files, index + 1, callbackAfterFinish, disImages);
      } else {
        callbackAfterFinish(disImages, 1);
      }
    }
  };
  const onChoosePhoto = async (event) => {
  if (event.target.files && event.target.files.length > 5) {
    // alert("You can only upload a maximum of 5 images at a time.");
    setAlertDialog(true);
    return;
  }
    if (event.target.files && event.target.files[0]) {
      setCurrentImage(event.target.files[0]);
      const FilesArr = [];

      for (let fileKey in event.target.files) {
        const file = event.target.files[fileKey];

        if (file?.type) {
          FilesArr.push(file);
        }
      }
      if (FilesArr.length > 0) {
        for (let index = 0; index < FilesArr.length; index++) {
          const extraLimit = auth?.userProfile?.additionalQuantity * 5;
          const extraLimitInBytes = extraLimit * 1024 ** 3;
          const storageLimit =
            (allowedPermissions?.storageLimits ?? 0) + extraLimitInBytes;
          if (
            auth?.userProfile?.storage + FilesArr[index].size >
            storageLimit
          ) {
            setDialogOpen(true);
            FilesArr.splice(index, 1);
            continue;
          }
          resizeImage(
            FilesArr,
            index,
            (disImages, isSuccess) => {
              setDisplayImage(disImages);
              uploadPhoto(FilesArr[index], FilesArr, index, [...imageLink]);
            },
            [...displayImage]
          );
        }
      }
    } else {
      // this.setState({isLoading: false})
    }
  };

  const removeSelectedImage = (index, isDelete = true) => {
    if (isDelete) {
      if (imageLink.length > 0 && imageLink[index]) {
        const fileRef = ref(getStorage(), imageLink[index]);
        const imgLink = [...imageLink];
        imgLink.splice(index, 1);
        setImageLink(imgLink);
        const disImage = [...displayImage];
        disImage.splice(index, 1);
        setDisplayImage(disImage);

        deleteObject(fileRef)
          .then(() => {
            console.log("File Deleted");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setImageLink([]);
      setDisplayImage([]);
    }
    imgRef.current.value = "";
  };

  const handleDialogClose = () => {
    setAlertDialog(false);
  }

  const checkSendIsDisbaled = () => {
    const userData = employee?.find(
      (item) => item?.userId === auth.userProfile.id
    );
    if (auth?.userProfile?.role === "Client") {
      return false;
    } else if (userData?.status === false) {
      return false;
    } else if (currentImage !== "" && imageLink.length > 0) {
      return false;
    } else if (currentImage === "" && imageLink.length === 0) {
      return msgText.trim() === "";
    } else if (msgText.trim().length > 0) {
      return false;
    }
    return true;
  };
  return (
  <>
    <div
      className="msgBoxsender w-100"
      key="msgBoxsender"
      // style={{ alignItems: !hasMediaAccess ? "flex-end" : "" }}
    >
      {displayImage.length > 0 ? (
        <div className="flex flex-wrap gap-4 bg-[#f1f5f9] dark:bg-[#1A1F2C] p-16 rounded-md" key="selectedImage">
          {displayImage?.map((item, index) => (
            <div key={`${new Date().toISOString()}${index}`} className="relative w-[80px] h-[80px] rounded-md overflow-hidden bg-white shadow-md">
              <button
                type="button"
                onClick={() => removeSelectedImage(index)}
                className="absolute top-1 right-1 bg-white rounded-full p-1 shadow hover:bg-gray-200 transition"
              >
                <X size={16} className="text-gray-600" />
              </button>

              <img
                src={item}
                alt={`preview-${index}`}
                onClick={() => setPreviewImage(item)}
                className="w-full h-full object-cover"
              />

              {!imageLink[index] && (
                <div className="absolute inset-0 flex items-center justify-center bg-white/70">
                  <CircularProgress size={20} />
                </div>
              )}
            </div>
          ))}

          <div key="addbutton" className="w-[80px] h-[80px] flex items-center justify-center bg-gray-300 rounded-md cursor-pointer hover:bg-gray-400 transition" onClick={() => imgRef.current.click()}>
            <span className="text-white text-xl">+</span>
          </div>
        </div>
      ) : null}
      {previewImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <button
            onClick={() => setPreviewImage(null)}
            className="absolute top-4 right-4 bg-white rounded-full p-4 hover:bg-gray-200 transition z-50"
          >
            <X size={20} className="text-gray-700" />
          </button>
          <div className="max-w-[95vw] max-h-[95vh] flex items-center justify-center">
            <img
              src={previewImage}
              alt="Full Preview"
              className="w-auto h-auto max-w-full max-h-full object-contain rounded-md shadow-2xl"
            />
          </div>
        </div>
      )}
      <div className="d-flex mt-10">
        <input
          ref={imgRef}
          accept="image/*"
          type="file"
          multiple
          onChange={onChoosePhoto}
          className="sr-only"
           max={5} 
        />
        {/* {hasMediaAccess && ( */}
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => {
              imgRef.current.click();
            }}
            className="shrink-0"
          >
            <Paperclip size={18} />
          </Button>
        {/* )} */}
        <Textarea
          key="autoresizetext"
          minRows={5}
          className="msgTextbox mh-10"
          placeholder="Type here to send message..."
          value={msgText}
          onChange={onChangeTextHandler}
          maxLength={300}
        />
        <div className="buttonContainer" key="buttonContainer">
          <Button
            variant=""
            onClick={sendMessage}
            disabled={checkSendIsDisbaled()}
          >
            <ArrowUp />
          </Button>
        </div>
      </div>
    </div>

    <CommonSuccessDialog 
      open={alertDialog}
      onClose={handleDialogClose}
      title="Upload Limit Reached"
      message="You can only upload a maximum of 5 images at a time."
    />
  </>
  );
};

const MessageElement = ({ message, onMSGItemClick, auth, isCurrentUser }) => {
  const containerFlexClass = isCurrentUser ? "flex-row-reverse" : "flex-row";

  return (
    <div className="flex flex-col w-full">
      {message?.imagesObj && message?.imagesObj?.length > 0 ? (
        <>
          {message?.imagesObj?.map((element, index) => {
              const isArrayCimage = Array.isArray(element?.cimage);
              const cimages = isArrayCimage ? element?.cimage : [element?.cimage];
              const fullImages = Array.isArray(element?.image) ? element?.image : [];

            return (
              <div  className={`mt-10 w-full flex ${containerFlexClass} items-start gap-3`}>
                <div className="nameBox">
                  <Avatar className="h-8 w-8">
                    <AvatarFallback className="dark:bg-[#0F1729] bg-[#F1F5F9] dark:text-white text-[#020817]"
                    >
                      {[message?.sender?.firstName, message?.sender?.lastName]
                        ?.filter(Boolean)
                        ?.map((n) => n.split(" ")[0][0])
                        ?.join("")}
                    </AvatarFallback>
                  </Avatar>
                </div>
                <div className="msgTextBox ml-12">
                  <div className="dtDisplay dark:text-[#6B7280]">
                    {`${message.sender.firstName} ${
                      message.sender.lastName
                    }, ${moment(message.updatedOn).format("hh:mm a")}`}{" "}
                  </div>
                    {element.type === "image" &&
                    cimages.length > 0 &&
                    cimages.map((cimg, i) => {
                      if (!cimg || typeof cimg !== "string") return null;

                      const fullImg = fullImages[i] || cimg;
                      return (
                        <div className="imageDisplay mt-4" key={i}>
                          <ModalImage
                            small={cimg}
                            large={fullImg}
                            alt={element?.message || `image-${i}`}
                            showRotate
                          />
                        </div>
                      );
                    })}
                  {element?.message !== "" && (
                    <div
                    className={`mt-4 rounded-lg p-12 text-sm ${
                      auth.userProfile.id === message.sender.userId
                      ? "bg-green-600 text-white dark:bg-[#0F1729] dark:text-white "
                      : "bg-[#f1f5f9] text-black dark:bg-[#0F1729] dark:text-white "
                      }`}
                      >
                    {element?.message}
                  </div>
                  )}
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className={`mt-10 w-full flex ${containerFlexClass} items-start gap-3`}>
          <Avatar className="h-8 w-8">
            <AvatarFallback className="dark:bg-[#0F1729] bg-[#F1F5F9] dark:text-white text-[#020817]"
            >
              {[message?.sender?.firstName, message?.sender?.lastName]
                ?.filter(Boolean)
                ?.map((n) => n.split(" ")[0][0])
                ?.join("")}
            </AvatarFallback>
          </Avatar>

          <div className="msgTextBox ml-12">
            <div className="dtDisplay dark:text-[#6B7280]">
              {`${message?.sender?.firstName} ${
                message?.sender?.lastName
              }, ${moment(message?.updatedOn).format("hh:mm a")}`}{" "}
            </div>
            <div
              className={`mt-4 rounded-lg p-12 text-sm ${
                auth.userProfile.id === message.sender.userId
                  ? "bg-green-600 text-white dark:bg-green-600 dark:text-white "
                  : "bg-[#f1f5f9] text-black dark:bg-[#0F1729] dark:text-white "
              }`}
            >
              {message?.message}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const DisplayMessagesBox = ({ currChannel, isMobile, isLandscape }) => {
  const [messages, setMessages] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [allMessages, setAllMessages] = useState([]);
  const [messageCount, setMessageCount] = useState(-10);

  const bottomRef = useRef(null);

  const auth = useContext(AuthContext);

  useEffect(() => {
    const unsubscribe = getMessages(
      currChannel.id,
      (res) => {
        if (res) {
          setMessages(res.slice(messageCount));
          setAllMessages(res);
          setTimeout(() => {
            setIsLoaded(true);
          }, 1000);
        }
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
    return () => {
      if (currChannel.readMsgUsers) {
        const channelUpdates = { ...currChannel };
        if (!currChannel.readMsgUsers.includes(auth.userProfile.id)) {
          channelUpdates.readMsgUsers.push(auth.userProfile.id);
        }
        updateChannel(currChannel.id, channelUpdates);
      }
      unsubscribe();
    };
  }, [currChannel]);

  useEffect(() => {
    if (bottomRef) {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }, [allMessages]);

  const checkPositionOfScroll = (e) => {
    if (
      isLoaded &&
      e.target.scrollTop <= 50 &&
      messageCount * -1 < allMessages.length
    ) {
      let mesCnt = messageCount;
      mesCnt += -1 * 10;
      setMessageCount(mesCnt);
      setMessages(allMessages.slice(mesCnt));
    }
  };
  const messageItemClick = (msgItem) => {
    // setLastImageURL(msgItem.image);
    // setIsLoadIMGPopup(true);
    // console.log(msgItem);
  };
  let dt = "";
  //h-[60vh]
  return (
    <>
      <ScrollArea className="h-full px-6 py-4">
        <div
          className="msgBox space-y-4"
          style={
            !isMobile && !isLandscape
              ? { height: window.innerHeight - 350 }
              : { height: "50vh" }
          }
          onScroll={checkPositionOfScroll}
        >
          {messages?.map((message) => {
            let msgDate = moment(message.updatedOn);
            let formattedDate;

            if (msgDate.isSame(moment(), "day")) {
              formattedDate = (
                <>
                  <span>Today</span>
                  <br />
                  <span style={{ color: "#1e1e1e", fontWeight: "500" }}>
                    {msgDate.format("DD MMMM, YYYY")}
                  </span>
                </>
              );
            } else if (msgDate.isSame(moment().subtract(1, "days"), "day")) {
              formattedDate = (
                <>
                  <span>Yesterday</span>
                  <br />
                  <span style={{ color: "#1e1e1e", fontWeight: "500" }}>
                    {msgDate.format("DD MMMM, YYYY")}
                  </span>
                </>
              );
            } else {
              formattedDate = (
                <>
                  <span>{msgDate.format("dddd")}</span>
                  <br />
                  <span style={{ color: "#1e1e1e", fontWeight: "500" }}>
                    {msgDate.format("DD MMMM, YYYY")}
                  </span>
                </>
              );
            }

            let returnArr = [];

            if (dt !== msgDate.format("DD MMMM, YYYY")) {
              returnArr.push(
                <div
                  className="messageContainer"
                  key={msgDate.format("DD MMMM, YYYY")}
                >
                  <div className="flex flex-justify-center text-center">
                  <div className="dtDisplay">{formattedDate}</div>
                </div>
                </div>
              );
              dt = msgDate.format("DD MMMM, YYYY");
            }

            if (
              String(auth.userProfile?.id) === String(message?.sender?.userId)
            ) {
              returnArr.push(
                <div className="messageContainer" key={message.id}>
                  <div
                    className="rightMsg"
                    // style={message?.type === "image" ? { width: "90%" } : {}}
                  >
                    <MessageElement
                      message={message}
                      onMSGItemClick={messageItemClick}
                      auth={auth}
                      isCurrentUser={true}
                    />
                  </div>
                </div>
              );
            } else {
              returnArr.push(
                <div className="messageContainer" key={message.id}>
                  <div
                    className="leftMsg"
                    // style={message?.type === "image" ? { width: "90%" } : {}}
                  >
                    <MessageElement
                      message={message}
                      onMSGItemClick={messageItemClick}
                      auth={auth}
                      isCurrentUser={false}
                    />
                  </div>
                </div>
              );
            }
            return returnArr;
          })}
          <div ref={bottomRef} />
        </div>
      </ScrollArea>
    </>
  );
};

function LiveChat(props) {
  const auth = useContext(AuthContext);
  const currChannel = auth.currentChannel;
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = React.useState("Private");
  const [employee, setEmployee] = React.useState([]);
  const navigate = useNavigate();
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;

  useEffect(() => {
    getAllEmployee((res) => {
      if (res && res?.data) {
        setEmployee(res?.data);
      } else {
        setEmployee([]);
      }
    });
    if (currChannel) {
      setActiveTab(currChannel?.type)
    }
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    auth.setCurrentChannel(null);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Container
        style={{ padding: isMobile || isLandscape ? "5px 0px 0px 0px" : "" }}
      >
        <PageTitle
          pageTitle="Chat Boards"
          showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Communications" }]}
          BreadCrumbCurrentPageTitle={
            currChannel?.groupName ? currChannel?.groupName : "Live Chat"
          }
          showLastSeen={true}
          live={true}
          {...(!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("admin") && !auth.userProfile.role.includes("Employee") : auth?.userProfile?.role === "admin") && {
          buttonTitle : "View Channels",
          icons: <Eye className="h-4 w-4 mr-5" />,
          buttonClass : "d-flex flex-center",
          buttonStyle : {
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          },
          buttonClick : () => navigate("/communications/message-board/manage-channel")
        })}
        />
        <div className="p-24">
          <div className="flex items-center justify-between mb-24">
            <div>
              <h1 className="text-3xl font-bold tracking-tight text-foreground">Live Chat</h1>
              <p className="text-muted-foreground">
                Communicate in real-time with your team and clients
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {isMobile && currChannel ? (
              // Chat view on mobile
              <div className="lg:col-span-12">
                <Card className="h-full flex flex-col bg-white shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                  <CardHeader className="pb-12 ph-24 pt-24 border-b">
                    <div className="flex items-center">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleTabClick(activeTab)}
                        className="mr-8"
                      >
                        <ArrowLeft className="h-5 w-5" />
                      </Button>
                      <div className="flex-1">
                        <CardTitle>{currChannel?.groupName}</CardTitle>
                        <Badge
                          className="mt-12"
                          variant={
                            activeTab === "Private" ? "success" : "outline"
                          }
                        >
                          {activeTab}
                        </Badge>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent className="flex-1 overflow-hidden">
                    <DisplayMessagesBox currChannel={currChannel} />
                  </CardContent>
                  <CardFooter className="border-t p-12">
                    <SendTextMessageBox
                      currChannel={currChannel}
                      employee={employee}
                      companyId={companyId}
                      setDialogOpen={setDialogOpen}
                    />
                  </CardFooter>
                </Card>
              </div>
            ) : isMobile ? (
              // Channels list view on mobile
              <div className="lg:col-span-12">
                <Card className="h-full p-24 bg-white shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                  <CardHeader className="pb-12">
                    <CardTitle className="dark:text-white">Channels</CardTitle>
                    <CardDescription>
                      Select a channel to start chatting
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="px-0">
                    <ChatLeftPannel
                      activeTab={activeTab}
                      isMobile={isMobile}
                      isLandscape={isLandscape}
                      setActiveTab={setActiveTab}
                    />
                  </CardContent>
                </Card>
              </div>
            ) : (
              <>
                <div className="lg:col-span-4 xl:col-span-3">
                  <Card className="p-24 bg-white shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] my-scroll" style={{height:"75vh"}}>
                    <CardHeader className="pb-12">
                      <CardTitle className="dark:text-white">Channels</CardTitle>
                      <CardDescription>
                        Select a channel to start chatting
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="px-0">
                      <ChatLeftPannel
                        activeTab={activeTab}
                        isMobile={isMobile}
                        isLandscape={isLandscape}
                        setActiveTab={setActiveTab}
                      />
                    </CardContent>
                  </Card>
                </div>
                <div className="lg:col-span-8 xl:col-span-9">
                  <Card className="flex flex-col bg-white shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]" style={{height:"75vh"}}>
                    {currChannel ? (
                      <>
                        <ChatHeader
                          channel={currChannel}
                          activeTab={activeTab}
                        />
                        <CardContent className="flex-1 overflow-hidden h-full p-0">
                          <DisplayMessagesBox currChannel={currChannel} />
                        </CardContent>
                        <CardFooter className="border-t p-12">
                          <SendTextMessageBox
                            currChannel={currChannel}
                            employee={employee}
                            companyId={companyId}
                            setDialogOpen={setDialogOpen}
                          />
                        </CardFooter>
                      </>
                    ) : (
                      <EmptyStateMessage />
                    )}
                  </Card>
                </div>
              </>
            )}
          </div>
        </div>

      </Container>
      {dialogOpen && (
        <StorageLimitAccess
          open={dialogOpen}
          onClose={handleDialogClose}
          auth={auth}
        />
      )}
    </>
  );
}

export default LiveChat;
